<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>Everything written in this book was done while in the midst of a manic episode with psychotic features. My formal diagnosis is schizoaffective disorder, bipolar type as well as ADHD.</p>
<p>I can’t define this book as fiction or non-fiction. It’s merely my thoughts and a form of processing.</p>
<p>Please take what you will from it and leave what doesn’t resonate.</p>
<p><em>I am only human.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?aad057a6